(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorClinicNameDialogController', SectorClinicNameDialogController);

    SectorClinicNameDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SectorClinicName', 'Sector', 'ClinicName'];

    function SectorClinicNameDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SectorClinicName, Sector, ClinicName) {
        var vm = this;
        vm.sectorClinicName = entity;
        vm.sectors = Sector.query();
        vm.clinicnames = ClinicName.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorClinicNameUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.sectorClinicName.id !== null) {
                SectorClinicName.update(vm.sectorClinicName, onSaveSuccess, onSaveError);
            } else {
                SectorClinicName.save(vm.sectorClinicName, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
